import { createContext } from 'react';
import EditCommerceCategoriesContext from 'types/contexts/EditCommerceCategoriesContext';

export default createContext({} as EditCommerceCategoriesContext);
